import { axaBlue, deepSapphire, wildSand, darkIndigo, dustyGray, mineshaft,
  white, silver } from './colors';

export default {
  fontFamily: 'Source Sans Pro, Arial , sans-serif',
  palette: {
    primary1Color: axaBlue,
    primary2Color: deepSapphire,
    primary3Color: wildSand,
    accent1Color: darkIndigo,
    accent2Color: wildSand,
    accent3Color: dustyGray,
    textColor: mineshaft,
    secondaryTextColor: dustyGray,
    alternateTextColor: white,
    canvasColor: white,
    borderColor: dustyGray,
    disabledColor: silver,
    pickerHeaderColor: axaBlue,
    clockCircleColor: mineshaft,
    shadowColor: mineshaft
  }
};



// WEBPACK FOOTER //
// ./src/app/themes/axa/axa-theme.js